module.exports = __webpack_public_path__ + "r-v3/img/o.8cafb4b0.svg";